import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SubContractorsWiseEmployeesDto } from './sub-contractor-wise-employees-dto';

export class SubContractorsWiseEmployeesResponseModel extends GlobalResponseObject {
    data?: SubContractorsWiseEmployeesDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SubContractorsWiseEmployeesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

